import {inmsg342DefFilters} from "./InmsgTable";
import QrFromImage from "./actions/QrFromImage";
import {schemas} from "../config";
import Act342WinnerEmail from "./actions/Act342WinnerEmail";

export const act342Functions = {
    inmsg342DefFilters: () => inmsg342DefFilters(),
    uniqueId342Qr: (value, schema, forHeader = false, record = null) => record ?
        <QrFromImage value={value} id={record['id']}
                     imageUrl={schemas['act342'].backend + "/proxy.php?url=" + encodeURIComponent(record["check_photo"])}/> : value,
    email342WinnersEmailAction: () => <Act342WinnerEmail/>
} as { [p: string]: (...args: any[]) => any }
